import "./styles.css";
import React, { useEffect, useState, useRef } from "react";
import { authenticate } from "../../../services/core/authentication";
import { getUserSession, setUserSession } from "../../../util/core/Session";
import { useDispatch } from "react-redux";
import conf from "../../../../application/config/config";
import axios from "axios";

import { DEFAULT_CONFIGS } from "./configs/default_configs";

import { AiOutlineExclamationCircle } from "react-icons/ai";
import { MdLockOutline, MdOutlineMail, MdInfoOutline, MdPersonOutline } from "react-icons/md";
import config from "../../../../application/config/config";
import Fetch from "../../../util/core/Fetch";

const RECAPTCHA_SECRET_KEY = conf.tokens.recaptcha_secret;

function Login() {
  const dispatch = useDispatch();

  const inputRef = useRef(null);

  const [screenConfigs, setScreenConfigs] = useState(DEFAULT_CONFIGS);

  const [loadingConfigs, setLoadingConfigs] = useState(true);
  const [loginLoading, setLoginLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  let [form, updateForm] = useState({
    login: "",
    password: "",
    keep_logged: false,
  });

  const handleChange = (event) => {
    if (event.target.type === "checkbox") {
      return updateForm({ ...form, [event.target.name]: event.target.checked });
    }
    updateForm({ ...form, [event.target.name]: event.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setErrorMessage(null);

    const { isAuthenticated, msg } = await authenticate(form.login, form.password, screenConfigs);

    if (isAuthenticated) {
      setLoginLoading(true);
      const userSession = getUserSession();

      dispatch({ type: "UPDATE_SESSION", key: "userSession", value: userSession });

      if (userSession.user.is_first_access === '1') {
        window.location.replace("/core/users/useredit");

        return;
      };

      window.location.replace(userSession.user.initial_path ? userSession.user.initial_path : "/");
    } else {
      setErrorMessage(msg);

      updateForm({ ...form, password: "" });
    }
  };

  const loadScreenConfigs = async () => {
    const currentURL = window.location.href;
    const requestData = { urlVa: currentURL };

    axios.post(`${conf.endpoints.backend}core/loginconfigs/getloginconfigs`, requestData)
      .then((resp) => {
        let server_configs = resp.data;

        if (server_configs.logo_img) {
          server_configs.logo_img = server_configs.logo_img;
        } else {
          server_configs.logo_img = DEFAULT_CONFIGS.logo_img;
        }

        if (server_configs.isotype_img) {
          server_configs.isotype_img = server_configs.isotype_img;
        } else {
          server_configs.isotype_img = DEFAULT_CONFIGS.isotype_img;
        }

        if (server_configs.background_img) {
          server_configs.background_img = server_configs.background_img;
        } else {
          server_configs.background_img = DEFAULT_CONFIGS.background_img;
        }

        setScreenConfigs(server_configs);
      })
      .catch((error) => {
        console.error('Erro ao carregar as configurações de tela:', error);
      }).finally(() => {
        setLoadingConfigs(false)
      });
  };

  // reCaptcha
  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SECRET_KEY}`;
    script.addEventListener("load", () => {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(RECAPTCHA_SECRET_KEY).then((token) => updateForm({ ...form, captcha: token }));
      });
    });
    document.body.appendChild(script);
  }, [errorMessage]);


  useEffect(() => {
    loadScreenConfigs();

    const handleKeyPress = (event) => {
      if (event.key === 'Enter') {
        inputRef.current.click();
      }
    };

    // Adiciona o listener de evento para capturar a tecla "Enter" pressionada
    document.addEventListener('keypress', handleKeyPress);

    // Remove o listener de evento quando o componente é desmontado
    return () => {
      document.removeEventListener('keypress', handleKeyPress);
    };
  }, []);

  useEffect(() => {

    if (screenConfigs?.favicon_img) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      link.href = screenConfigs?.favicon_img;
    }

  }, [screenConfigs]);


  const overlayColor = () => {
    const banner_overlay_opacity = screenConfigs.banner_overlay_opacity;

    const transparencyValue = banner_overlay_opacity
      ? banner_overlay_opacity > 100
        ? 100
        : banner_overlay_opacity < 0
          ? 0
          : banner_overlay_opacity
      : 0;

    const alphaValue = Math.round((transparencyValue / 100) * 255);
    const hexOpacity = alphaValue.toString(16).toUpperCase().padStart(2, "0");
    const backgroundColor = `${screenConfigs.banner_primary_color}${hexOpacity}`;

    return backgroundColor;
  };


  if (loadingConfigs) {
    return (
      <div className='loading-overlay' style={{ backgroundColor: 'transparent' }}>
        <div class='spinner'></div>
        <span style={{ color: "gray" }}>Carregando...</span>
      </div>
    )
  }


  return (
    <>
      {loginLoading && (
        <div className='loading-overlay'>
          <div class='spinner'></div>
          <span>Carregando...</span>
        </div>
      )}
      <div
        className='login-main-container'
        style={{
          flexDirection: screenConfigs?.form_position === "RIGHT" ? "row-reverse" : "row",
          filter: `${loginLoading ? "blur(1px)" : "blur(0px)"}`,
        }}
      >
        <div className='login-form-side'>
          <a href='#'>
            <img src={screenConfigs?.isotype_img} style={{ maxHeight: "50px" }} />
          </a>
          <div className='login-form-header'>
            <h2 className='login-form-header-title'>{screenConfigs?.title}</h2>
            {screenConfigs?.subtitle && <h3 className='login-form-header-subtitle'>{screenConfigs?.subtitle}</h3>}
            <p className='login-form-header-msg'>Informe seus dados para acesso.</p>
          </div>
          <div className='login-form-body'>
            <div className='login-form-inputs-container'>
              <form>
                <div className='login-form-input'>
                  <label htmlFor=''>E-mail/ Login</label>
                  <div
                    className='login-form-input-field'
                    style={errorMessage ? { borderColor: "#dc3545", backgroundColor: "#fff1f3" } : null}
                  >
                    <MdPersonOutline size={24} color={errorMessage ? "#dc3545" : "#808080"} />
                    <input
                      value={form.login}
                      name='login'
                      onChange={handleChange}
                      placeholder='Insira seu e-mail'
                      ref={inputRef}
                      style={errorMessage ? { boxShadow: "0 0 0 30px #fff1f3 inset" } : null}
                    />
                  </div>
                </div>
                <div className='login-form-input'>
                  <label htmlFor=''>Senha</label>
                  <div
                    className='login-form-input-field'
                    style={errorMessage ? { borderColor: "#dc3545", backgroundColor: "#fff1f3" } : null}
                  >
                    <MdLockOutline size={24} color={errorMessage ? "#dc3545" : "#808080"} />
                    <input
                      value={form.password}
                      name='password'
                      onChange={handleChange}
                      type='password'
                      placeholder='Insira sua senha'
                      style={errorMessage ? { boxShadow: "0 0 0 30px #fff1f3 inset" } : null}
                    />
                  </div>
                </div>
                <div className='login-form-error-message'>
                  {errorMessage && (
                    <>
                      <AiOutlineExclamationCircle size={16} color={"#dc3545"} />
                      <span>{errorMessage}</span>
                    </>
                  )}
                </div>
                <div className='login-form-options'>
                  <div className='login-form-option-keep-conected'>
                    <input
                      type='checkbox'
                      name='keep_logged'
                      id='keep_logged'
                      checked={form.keep_logged}
                      onChange={handleChange}
                    />
                    <span>Mantenha-me conectado</span>
                  </div>
                  <a href='forgotPassword'>Esqueci Minha Senha</a>
                </div>
              </form>
            </div>
          </div>
          <div className='login-form-footer'>
            <button
              onClick={handleSubmit}
              ref={inputRef}
              className='btn btn-primary btn-block'
              style={{ backgroundColor: screenConfigs?.primary_color, border: "none" }}
            >
              Entrar
            </button>
            <div className='login-form-footer-terms'>
              {screenConfigs?.terms_condition_show === "1" && (
                <>
                  <MdInfoOutline size={22} color='#0178FF' />
                  <span>
                    Confira nossos <a href='#'>Termos & Condições</a>
                  </span>
                </>
              )}
              {config?.[config?.application_name]?.version && (
                <div className="d-flex align-items-center">
                  <MdInfoOutline size={22} color='#0178FF' />
                  <span className="ml-2 text-secondary">
                    Versão {config?.[config?.application_name]?.version}
                  </span>
                </div>
              )}
            </div>
            <div className='copyright-text'>
              {screenConfigs?.has_copyright === "1" && (
                  <span>
                    {screenConfigs?.copyright}
                  </span>
              )}
            </div>
          </div>
        </div>
        <div
          className='login-hero-img-side'
          style={{
            color: "#aeaeae",
            backgroundImage: `url(${screenConfigs?.background_img})`,
          }}
        >
          <img src={screenConfigs?.logo_img} alt='Rs Holding Logo' />
          <div
            className='filter-overlay'
            style={{
              backgroundColor: overlayColor(),
            }}
          ></div>
        </div>
      </div>
    </>
  );
}

export default Login;